module.exports = __webpack_public_path__ + "./fonts/icomoon.328b0f.ttf";